import { NgClass, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SizePickerAbstract } from 'src/app/layout/common/components/size-picker.abstract';

@Component({
  selector: 'app-default-size-picker',
  templateUrl: './default-size-picker.component.html',
  styleUrls: ['./default-size-picker.component.scss'],
  standalone: true,
  imports: [NgFor, MatButtonModule, NgClass]
})
export class DefaultSizePickerComponent extends SizePickerAbstract { }
